import React from 'react'

const Card = (props) => {

  const createMarkup = (html) => {
    return { __html: html };
  };

  return (
    <div className="timeline__item">
        <i className={props.icon}></i>
        <span className="timeline__date">{props.year}</span>
        <h3 className="timeline__title">{props.title}</h3>
        <div className="timeline__text">
        {String(props.desc).split('*').map((line, index) => (
          <p key={index} dangerouslySetInnerHTML={createMarkup(line.trim())}></p>
        ))}
        </div>
    </div>
  )
}

export default Card